package provider

import androidx.compose.runtime.*

val LocalWindowProvider = staticCompositionLocalOf<WindowProvider> { error("WindowProvider not defined") }

class WindowProvider {


    private var content = mutableStateListOf<(@Composable () -> Unit)>()

    @Composable
    fun attach(body: @Composable () -> Unit) {
        DisposableEffect(Unit) {
            content.add(body)
            onDispose {
                content.remove(body)
            }
        }
    }

    @Composable
    fun attachToWindow() {
        content.forEach {
            it()
        }
    }
}
